// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const transition: Styleguide["transition"] = {
    duration: {
        short: 100,
        regular: 250,
        long: 500,
    },
};

export default transition;
